

var _squid = require('squid');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$ShoppingCartFactory', function () {
    // DTOPPOR-795 move guest/signup traffic to Weasley
    // Experiment that controls if user should be redirected to hermes with "Pay without PayPal" button
    var getShouldRedirectToHermes = function getShouldRedirectToHermes() {
        return (0, _squid.$elmo)('xo_shoppingcart_checkout_button', {}, 'Trmt_xo_shoppingcart_checkout_button_redirect_to_hermes').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    };

    return {
        getShouldRedirectToHermes: getShouldRedirectToHermes
    };
});
_squid.$elmo;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/factory.js
// module id = ./pages/xo-shoppingcart/factory.js
// module chunks = 0